export default __webpack_public_path__ + "static/media/back_asset.95d51859.svg";